import React from 'react'
import { TabsPanelWithLock } from '../../components/tab-panel-with-lock'
import { ContextToolbar } from '@guillotinaweb/react-gmi'
import { useTraversal } from '@guillotinaweb/react-gmi'
import { PanelPermissions } from '@guillotinaweb/react-gmi'
import { PanelBehaviors } from '@guillotinaweb/react-gmi'
import { PanelProperties } from '@guillotinaweb/react-gmi'
import { AuditLogTab } from '../../common/auditlog'
import { SEOTab } from '../../components/seo-tab'
import { SubmenuTab } from '../../components/submenu-tab'

export function TagsView(props) {
  const ctx = useTraversal()
  const isGrape = ctx.state.path.startsWith('/tags/uva/')

  const tabs = {
    Properties: PanelProperties,
    Permissions: PanelPermissions,
    Behaviors: PanelBehaviors,
    AuditLog: AuditLogTab,
    Submenu: SubmenuTab,
  }
  const tabsPermissions = {
    Properties: 'guillotina.ModifyContent',
    Permissions: 'guillotina.SeePermissions',
    Behaviors: 'guillotina.ModifyContent',
    AuditLog: 'vinissimus.ViewLogs',
    Submenu: 'guillotina.ModifyContent',
  }

  if (isGrape) {
    tabs.SEO = () => <SEOTab withH1 />
    tabsPermissions.SEO = 'guillotina.ModifyContent'
  }

  const calculated = ctx.filterTabs(tabs, tabsPermissions)
  return (
    <TabsPanelWithLock
      tabs={calculated}
      currentTab="Properties"
      editableTabs={[]}
      rightToolbar={<ContextToolbar {...props} />}
      {...props}
    />
  )
}
